<template lang="pug">
  div
    v-sheet
      v-skeleton-loader(:loading="loadingCoupons" :transition="transition" height="400" type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line")
        NoResults(v-if="coupons.length === 0" title='No tienes cupones', description='Invita a tus amigos a usar Tender con tu código de referido y gana cupones')
        v-list(v-else two-line="" subheader="")
          v-subheader(inset="") Cupones
          v-list-item(v-for="coupon in coupons" :key="coupon.title" @click="showDetailsCoupon(coupon)")
            v-list-item-avatar
              v-icon(v-if="coupon.used" class="grey lighten-1 white--text") mdi-sale
              v-icon(v-else class="green accent-4 white--text") mdi-sale
            v-list-item-content
              v-list-item-title(v-text="coupon.title")
              v-list-item-subtitle(v-if="coupon.used")
                | {{coupon.details}} - Código: {{coupon.code}} - Cupón usado
              v-list-item-subtitle(v-else)
                | {{coupon.details}} - Código: {{coupon.code}} - Cupón disponible
        v-dialog(v-model="detailsCouponDialog")
          v-card.mx-auto(color="primary" dark="" max-width="400")
            v-card-title
              h2.font-weight-bold {{title}}
              v-icon(color="white" medium left="" @click="detailsCouponDialog = false") mdi-close
            v-card-text.headline.font-weight-bold
              | {{details}}
            v-card-actions
              v-list-item.grow
                v-list-item-avatar(color="grey darken-3")
                  v-img.elevation-6(src="https://www.shareicon.net/data/512x512/2016/06/30/788782_money_512x512.png")
                v-list-item-content
                  v-list-item-title {{code}}
                v-row(align="center" justify="end")
                  span.subheading.mr-2 {{used}}
                  span.mr-1 ·
                  span.subheading.mr-2 Valor: {{value}}
</template>

<script>
  export default {
    components: {
      NoResults: () => import('@/components/custom/NoResults.vue'),
    },
    data () {
      return {
        loadingCoupons: true,
        detailsCouponDialog: false,
        title: '',
        details: '',
        value: 0,
        code: '',
      }
    },
    computed: {
      coupons () {
        const coupons = this.$store.getters['referrals/getCoupons']
        // console.log(coupons, 'Cuponeees')
        return coupons
      },
    },
    created () {
      this.$store.dispatch('referrals/getAllCoupons').then(() => {
        this.loadingCoupons = false
      })
    },
    methods: {
      showDetailsCoupon (coupon) {
        this.title = coupon.title
        this.details = coupon.details
        this.value = coupon.value
        this.code = coupon.code
        if (coupon.used) {
          this.used = 'Usado'
        } else {
          this.used = 'Disponible'
        }
        this.detailsCouponDialog = true
      },
    },
  }
</script>
